import { parseNumber, parseString, transformModel } from '~/src/dash/api/resource-transforms';
import {
  addDomainAndTokenToUrl,
  IHttpResponse,
  restDelete,
  restGet,
  restPatch,
  restPost,
} from '~/src/dash/api/rest';

export interface IGlobalAppBundleBlockList {
  ID: number;
  CreatedAt?: string;
  UpdatedAt?: string;
  DeletedAt?: string;

  AppBundleID: string;
  ExemptPublisherIDs: string;
  ExemptResellerIDs: string;
}

export const transformGlobalAppBundleBlockList = transformModel<IGlobalAppBundleBlockList>({
  ID: parseNumber(['ID']),
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt',
  DeletedAt: 'DeletedAt',

  AppBundleID: parseString(['AppBundleID']),
  ExemptPublisherIDs: parseString(['ExemptPublisherIDs']),
  ExemptResellerIDs: parseString(['ExemptResellerIDs']),
});

// GET all getGlobalAppBundleBlockList
// /publishers/{publisherID}/dooh_venue_multiplier_map_pairs
export async function getGlobalAppBundleBlockList(
  publisherID: string,
): Promise<IGlobalAppBundleBlockList[]> {
  const reqUrl = addDomainAndTokenToUrl(`/publishers/${publisherID}/global_app_bundle_block_list`);
  return await restGet<IGlobalAppBundleBlockList[]>(reqUrl, {}).then(
    (val: IHttpResponse<IGlobalAppBundleBlockList[]>) => {
      return val.parsedBody ? val.parsedBody.map(transformGlobalAppBundleBlockList) : [];
    },
  );
}

// DELETE a single entry
export async function deleteGlobalAppBundleBlockListEntry(
  entryID: number,
  publisherID: string,
): Promise<IHttpResponse<{ status: boolean }>> {
  const reqUrl = addDomainAndTokenToUrl(
    `/publishers/${publisherID}/global_app_bundle_block_list/${entryID}`,
  );
  return await restDelete<{ status: boolean }>(reqUrl, undefined);
}

// UPDATE the globalAppBundleBlockList
export async function updateGlobalAppBundleBlockList(
  updatedBlockList: IGlobalAppBundleBlockList[],
  publisherID: string,
): Promise<IGlobalAppBundleBlockList[]> {
  const partialUrl = addDomainAndTokenToUrl(
    `/publishers/${publisherID}/global_app_bundle_block_list`,
  );
  return await restPatch<IGlobalAppBundleBlockList[]>(
    partialUrl,
    updatedBlockList.map(transformGlobalAppBundleBlockList),
  ).then((resp: IHttpResponse<IGlobalAppBundleBlockList[]>) => {
    return resp.parsedBody ? resp.parsedBody : [];
  });
}

// CREATE global_app_bundle_block_list
export async function createGlobalAppBundleBlockList(
  blockListEntry: IGlobalAppBundleBlockList,
  publisherID: string,
): Promise<IGlobalAppBundleBlockList> {
  const reqUrl = addDomainAndTokenToUrl(`/publishers/${publisherID}/global_app_bundle_block_list`);
  const globalBlockListEntry = transformGlobalAppBundleBlockList(blockListEntry);
  return await restPost<IGlobalAppBundleBlockList>(reqUrl, globalBlockListEntry).then(
    (val: IHttpResponse<IGlobalAppBundleBlockList>) => {
      return transformGlobalAppBundleBlockList(val.parsedBody);
    },
  );
}
